import { Box, Typography } from "@mui/material";
import LetterAvatar from "../../../../../../../../components/assignee/LetterAvatar";
import { timePassedSince } from "../../../../../../../../utils/timestamp";

import useColors from "../../../../../../../../api/hooks/useColors";
import ActionButtons from "./ActionButtons";

export default function RegularCommentBlock({ log, isHovered }) {
  const colors = useColors();

  return (
    <Box display="flex" flexDirection="column" gap={1} padding="4px">
      <Box display="flex" justifyContent="space-between">
        <Box height="25px" display="flex" alignItems="center" gap={1}>
          <LetterAvatar name={log.user_display_name} />
          <Typography
            variant="subtitle2"
            color={colors.text_primary}
            fontWeight={500}
          >
            {log.user_display_name}
          </Typography>
          <Typography variant="caption" color={colors.text_secondary}>
            {timePassedSince(log.log_timestamp.timestamp_utc)}
          </Typography>
        </Box>
        {isHovered && <ActionButtons log={log} handleEdit={() => {}} />}
      </Box>
      <Typography variant="body2" color={colors.text_secondary}>
        {log.content}
      </Typography>
    </Box>
  );
}
